import axios from "axios";

const HOST_API = process.env.REACT_APP_URL;

export const getAdministraciones = (soloNoDemo = true) =>
  axios.get(`${HOST_API}api/administraciones/GetAdministraciones`, {
    params: { soloNoDemo },
  });

// Listado de gestion para el Superadmin (incluye inactivas).
export const getAdministracionesAdmin = () =>
  axios.get(`${HOST_API}api/administraciones/GetAdministracionesAdmin`);

// Alta/edicion (upsert por administracionId).
export const saveAdministracion = (payload) =>
  axios.post(`${HOST_API}api/administraciones/SaveAdministracion`, payload);

export const getMenuOcultosAdministracion = (administracionId) =>
  axios.get(`${HOST_API}api/administracionMenu/GetMenuOcultos`, {
    params: { administracionId },
  });

export const saveMenuOcultosAdministracion = (administracionId, menuKeysOcultos) =>
  axios.post(`${HOST_API}api/administracionMenu/SaveMenuOcultos`, {
    administracionId,
    menuKeysOcultos,
  });
